import React from 'react';
import { PagoEncuestaResultComponent } from '../../Components/Encuestas/PagoEncuestaResultComponent';

// A propósito SIN LogoHeader/NavDesktop/NavMobile/Footer (Parte 13): esta
// pantalla puede abrirse sin sesión desde un navegador externo tras Redsys,
// y el chrome general de la web pública (enlaces a login/perfil) es
// justamente lo que hacía parecer "vuelve a la aplicación general" en vez
// de mostrar un recibo limpio. Ver PagoEncuestaResultComponent.css.
export const PagoEncuestaOkPage = () => (
  <PagoEncuestaResultComponent mode="ok" />
);
